import { render, staticRenderFns } from "./seurantajaksot-card.vue?vue&type=template&id=64b7de38&scoped=true&"
import script from "./seurantajaksot-card.vue?vue&type=script&lang=ts&"
export * from "./seurantajaksot-card.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajaksot-card.vue?vue&type=style&index=0&id=64b7de38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7de38",
  null
  
)

export default component.exports